import React from 'react';
import PropTypes from 'prop-types';

import { Box, Grid, Typography } from '@mui/material';

const JobDurationSection = ({
  startDate,
  endDate,
  formattedStartDate,
  formattedEndDate,
  weeks,
  translate,
  typographySx,
}) => {
  if (!startDate || !endDate) return null;

  return (
    <Box>
      <Typography sx={typographySx.sectionHeader}>
        {translate('job.create.confirmation.jobDuration')}
      </Typography>
      <Grid container spacing={{ xs: 2, md: 6 }}>
        <Grid item xs={4} sx={{ minWidth: 0 }}>
          <Typography sx={typographySx.subHeader}>
            {translate('job.create.confirmation.startDate')}
          </Typography>
          <Typography sx={typographySx.value}>{formattedStartDate}</Typography>
        </Grid>
        <Grid item xs={4} sx={{ minWidth: 0 }}>
          <Typography sx={typographySx.subHeader}>
            {translate('job.create.confirmation.endDate')}
          </Typography>
          <Typography sx={typographySx.value}>{formattedEndDate}</Typography>
        </Grid>
        <Grid item xs={4} sx={{ minWidth: 0 }}>
          <Typography sx={typographySx.subHeader}>
            {translate('job.create.confirmation.totalWeeks')}
          </Typography>
          <Typography sx={typographySx.value}>
            {translate('job.create.confirmation.weeksCount', { count: weeks ?? 0 })}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

JobDurationSection.propTypes = {
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  formattedEndDate: PropTypes.string,
  formattedStartDate: PropTypes.string,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  translate: PropTypes.func.isRequired,
  typographySx: PropTypes.shape({
    sectionHeader: PropTypes.shape({}).isRequired,
    subHeader: PropTypes.shape({}).isRequired,
    value: PropTypes.shape({}).isRequired,
  }).isRequired,
  weeks: PropTypes.number,
};

export default JobDurationSection;
